import "./App.sass";

import React, { useContext, useEffect, useState } from "react";
import LoginForm from "./screens/login/LoginForm";
import Header from "./components/header/Header";
import { Context } from "./index";
import { observer } from "mobx-react-lite";
import RouterMain from "./router/Router";
import Spinner from "./components/UI/spinner/Spinner";
import { ThemeContext } from "./ThemeContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router-dom";

function App() {
  const { store } = useContext(Context);
  const theme = useContext(ThemeContext);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    if (localStorage.getItem("token")) {
      store
        .checkAuth()
        .then(() => {
          setLoading(false);
        })
        .catch();
    } else {
      setLoading(false);
    }
  }, [store]);

  return (
    <>
      {!loading ? (
        <BrowserRouter>
          <Header position={store.isAuth ? "relative" : ""} />
          {store.isAuth == true ? (
            <div className={`RouterSidebar ${theme.theme}`}>
              <RouterMain />
            </div>
          ) : (
            <LoginForm />
          )}
        </BrowserRouter>
      ) : (
        <div className="mainLoading">
          <Spinner />
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default observer(App);
